import React from 'react';
import Route from 'react-router-dom/Route';
import { spring, AnimatedSwitch } from 'react-router-transition';

import HOME from '../../templates/home';
import DEFAULT from '../../templates/default';


// we need to map the `scale` prop we define below
// to the transform style property
function mapStyles(styles) {
  return {
    opacity: styles.opacity,
    transform: `scale(${styles.scale})`,
  };
}

// wrap the `spring` helper to use a bouncy config
function bounce(val) {
  return spring(val, {
    stiffness: 330,
    damping: 22,
  });
}

// child matches will...
const bounceTransition = {
  // start in a transparent, upscaled state
  atEnter: {
    opacity: 0,
    scale: 1,
  },
  // leave in a transparent, downscaled state
  atLeave: {
    opacity: bounce(0),
    scale: bounce(1),
  },
  // and rest at an opaque, normally-scaled state
  atActive: {
    opacity: bounce(1),
    scale: bounce(1),
  },
};

export default ({ pathname }) => {

  console.log('PATHNAME',pathname);

  return(
    
    <AnimatedSwitch
      atEnter={bounceTransition.atEnter}
      atLeave={bounceTransition.atLeave}
      atActive={bounceTransition.atActive}
      mapStyles={mapStyles}
      className="route-wrapper"
    >
      <Route exact path={"/"} render={() => ( <HOME/> )} /> 
      <Route exact path={"/:slug"} render={({match}) => ( <DEFAULT entry={match} /> )} /> 
      <Route path={"/404"} render={() => <div>Not Found</div>} />

    </AnimatedSwitch>

  );
};


// WEBPACK FOOTER //
// ./src/js/components/AnimatedRoutes/AnimatedRoutes.jsx